export default __webpack_public_path__ + "static/media/mallory_mp_compact_bold_italic.812d975c.ttf";